export default __webpack_public_path__ + "static/taskdefinition5-f65cbde79c45d2252ed3e003f0f4eb1b.png";